import { Action } from "../actions/actions";
import { SkeletonActionTypes } from "../actions/actionTypes";
import { Route } from "../api/apiTypes";
import _ from "lodash";

import permissionsJson from "../jsons/permissions.json";
import routes from "../jsons/routes.json"
// Game Import
// "games:configuration:load"
//"games:alias:create"

export function apiRoutes(state: Route[] = [], action: Action){
    switch (action.type) {
        /*
        case SkeletonActionTypes.GET_API_ROUTES:
            return state;

        case SkeletonActionTypes.GET_API_ROUTES_SUCCESS:
            return action.payload.data;
        */
        case SkeletonActionTypes.INITIALIZE_SUCCESS:
            return routes

        default:
            return state
    }
}

export function permissions(state: string[] = [], action: Action) {
    switch (action.type) {
        case SkeletonActionTypes.INITIALIZE_SUCCESS:
            const routes = _.reduce(
                action.payload.routes,
                (accum, value) => {
                    accum.push(value.name);
                    return accum;
                },
                []
            );

            let actions = [];
            permissionsJson.map(section => {
                section.actions.map(action => {
                    if (action.routes.every(route => routes.includes(route)))
                        actions.push(action.key);
                });
            });
            return actions;
        default:
            return state;
    }
}
